import { render, staticRenderFns } from "./dadataSuggest.vue?vue&type=template&id=138b9ac1&scoped=true"
import script from "./dadataSuggest.vue?vue&type=script&lang=js"
export * from "./dadataSuggest.vue?vue&type=script&lang=js"
import style0 from "./dadataSuggest.vue?vue&type=style&index=0&id=138b9ac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b9ac1",
  null
  
)

export default component.exports